import { DELETE, GET, PATCH, POST } from '../common/common.service'
import endpointsUsers from './endpoints'

const UsersService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsUsers.LOAD(filter, sort, limit, skip)),
  getUsersAccessFuelStation: async ({ filter, sort, limit, skip }) =>
    GET(endpointsUsers.LOAD_FUELSTATIONS(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsUsers.BY_USER(id)),
  getByIdHrInfo: async (id) => GET(endpointsUsers.BY_USER_HR_INFO(id)),
  getByIdJobInfo: async (id) => GET(endpointsUsers.BY_USER_JOB_INFO(id)),
  getByIdPersonalInfo: async (id) =>
    GET(endpointsUsers.BY_USER_PERSONAL_INFO(id)),
  updateHrInfo: async ({ _id, body }) =>
    PATCH(endpointsUsers.BY_USER_HR_INFO(_id), body),
  updateJobInfo: async ({ _id, body }) =>
    PATCH(endpointsUsers.BY_USER_JOB_INFO(_id), body),
  updatePersonalInfo: async ({ _id, body }) =>
    PATCH(endpointsUsers.BY_USER_PERSONAL_INFO(_id), body),
  create: async (body) => POST(endpointsUsers.CREATE, body),
  update: async ({ _id, body }) => PATCH(endpointsUsers.BY_USER(_id), body),
  remove: async (id) => {
    alert('remove')
    DELETE(endpointsUsers.BY_USER(id))
  },
}

export default UsersService
